<template>
  <v-layout :loading="loading">
    <template v-if="!loading">
      <d-header :breadcrumbs="false" fluid>
        <h1 class="title">
          {{ model.name }}
        </h1>
      </d-header>

      <d-container paddingless-mobile>
        <d-card class="mb-0">
          <d-card-row>
            <h2 class="title is-5">
              Details
            </h2>
            <ul>
              <li class="mb-2">
                {{ model.name }}
              </li>
            </ul>
          </d-card-row>
        </d-card>
      </d-container>
    </template>
  </v-layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
      __owner_business: this.title // for breadcrumb
    };
  },
  data() {
    return {
      model: {},
      loading: true
    };
  },
  computed: {
    title() {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    }
  },
  created() {
    this.$http
      .get(
        this.$laravel.route("api.owner-businesses.show", {
          owner_business: this.$route.params.ownerBusiness
        })
      )
      .then(response => {
        this.loading = false;
        this.model = response.data.data;
      })
      .catch(e => {
        console.error(e);
        this.$router.push("/owner-businesses");
      });
  }
};
</script>
